import React, { Component } from 'react';
import Container from 'react-bootstrap/Container';
import api from '../services/api';
import Image from 'react-bootstrap/esm/Image';
import ReactHtmlParser from 'react-html-parser';
import Row from 'react-bootstrap/esm/Row';
import Col from 'react-bootstrap/Col';

export default class Single extends Component{
   state = {
      dados:[]      
   };

   async componentDidMount(){
      const { slug } = this.props.match.params; 
      const { tipo } = this.props.match.params;
      const { data } = await api.get(`/${tipo}?slug=${slug}`);
      this.setState({ dados: data });
   }
   
   render(){
      const { dados } = this.state;  
      return (
         <Container>
            <div className="p-5 mt-5">
               { this.state.dados.map( (dado, index) => (
                  <Row key={index} sm={12} className="mb-4">
                     <Col>
                        <h2 className="text-center mb-3">{dado.title.rendered}</h2>
                        <div className="mx-lg-5">
                           <Image src={dado.imagem_destacada.guid} className="img-fluid rounded my-4 mx-auto d-block" />
                           { ReactHtmlParser(dado.content.rendered) }
                        </div>

                        

                     </Col>
                  </Row>
               )) }
            </div>
         </Container>
      )
   }
}